module.exports = __webpack_public_path__ + "img/ado_00.f276e020.svg";